import React from "react";
import "./Recent_Activity_Feed.css";
import { Navigate, useNavigate } from "react-router-dom";

function Recent_Activity_Feed() {
  const handleClick = (activityType) => {
    console.log("Activity clicked:", activityType);
  };

  const navigate = useNavigate();

  return (
    <div className="activity-container">
      {/* Header Parent Class */}
      <div className="activity-header">
        <span className="activity-title">Recent Activity Feed</span>
        <div className="activity-divider"></div>
      </div>

      {/* Button Grid Parent Class */}
      <div className="activity-row row g-2">
        <div className="col-md-4 col-12">
          <button
            className="activity-btn"
            onClick={() => navigate("/invoices")}
          >
            New Invoices
          </button>
        </div>
        <div className="col-md-4 col-12">
          <button
            className="activity-btn"
            onClick={() => navigate("/payment-received")}
          >
            Payments Received
          </button>
        </div>
        <div className="col-md-4 col-12">
          <button
            className="activity-btn"
            onClick={() => navigate("/inventory?filter=new")}
          >
            New Products Added
          </button>
        </div>
      </div>
    </div>
  );
}

export default Recent_Activity_Feed;
